import { useLocale } from 'next-intl';

import type { PageRachat } from '@/types/new-directus-types';
import type { PossibleLocales } from '@/utils/AppConfig';

import type { FaqItem } from '../types';

/**
 * Custom hook to get localized content from rachat page data
 * @param pageData - The rachat page data
 * @returns Localized intro, content and FAQ data
 */
export const useLocalizedContent = (pageData: PageRachat) => {
  const locale = useLocale() as PossibleLocales;

  return {
    intro: locale === 'fr' ? pageData.intro_fr : pageData.intro_en,
    contenu: locale === 'fr' ? pageData.contenu_fr : pageData.contenu_en,
    faqData: (locale === 'fr' ? pageData.faq_fr : pageData.faq_en) as
      | FaqItem[]
      | null,
  };
};
